export default `varying vec3 vColor;
uniform float size;

void main() {
  vColor = color;
  gl_PointSize = size;
  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
}`